<script>
    export let options;
    export let value;
    export let optionsname;

    export let id = "form-select"

</script>

<select id={id}
        class="form-control"
        bind:value
        on:change>
    <option value="" disabled selected>Select {optionsname}</option>
    {#each options as option}
        <option value={option.name}>{@html option.name}</option>
    {/each}
</select>

<style>
</style>
